<template>
  <div class="boards">
    <div class="page-info">
      <div class="columns">
            <div :class="'column is-2'">
    <b-menu>
    <b-menu-list label="Dashboard">
      <b-menu-item label="My projects" tag="router-link" to="/dashboard"></b-menu-item>
      <!-- <b-menu-item label="Pre-trained models" active></b-menu-item> -->
      <b-menu-item  label="Get started">
        <b-menu-item label="Docs and guides"></b-menu-item>
        <b-menu-item label="Discord channel"></b-menu-item>
        <b-menu-item label="Docs" tag="router-link" target="_blank" to="/docs"></b-menu-item>
      </b-menu-item>
    </b-menu-list>
    <b-menu-list>
      
      <b-menu-item label="Account" tag="router-link" to="/account/usage"></b-menu-item>

    </b-menu-list>
    <br>
    <b-menu-list label="Plan usage">
      <PlanUsage v-if="currentUser" :dashboard="true"/>
    </b-menu-list>
    <br>
    <b-menu-list label="Metatext community">
                    <div class="pt-1">
                        <p class="subtitle is-6">Get help, connect with founders and like-minded individuals.</p>
                        <b-field message="Join for free">
                        <b-button expanded type="is-primary is-center">
                           Join Discord channel
                        </b-button>
                        </b-field>
                    </div>
    </b-menu-list>
    <!-- <b-menu-list>
        <div class="cta-container">
                        <p>Upgrade your Metatext account for enhanced features!</p>
                        <br>
                        <b-button expanded @click="isModalPricingOpen = true" type="is-primary is-center">Upgrade</b-button>
                    </div>
    </b-menu-list> -->
  </b-menu>
    
<!--           
          <p>
            <b>
                <i class="fa fa-search"></i> Search
            </b>
          </p>
          <b-field label="">
              <b-autocomplete
                  v-model="search"
                  placeholder="e.g. Content moderation"
                  :data="models"
                  group-field="type"
                  field="name"
                  @select="option => (selected = option)"
                  :clearable="clearable"
              >
              </b-autocomplete>
            </b-field>

            <div class="buttons">
            <b-button size="is-small" rounded @click="search = 'Sentiment'">❤️ Sentiment Analysis</b-button>
            <b-button size="is-small" rounded  @click="search = 'Intent'">🗣 Intent Classification</b-button>
            <b-button size="is-small" rounded  @click="search = 'Emotion'">💬 Emotion Analysis</b-button>
            <b-button size="is-small" rounded  @click="search = 'Urgency'">🚨 Urgency Detection</b-button>
            <b-button size="is-small" rounded  @click="search = 'Topic'">📰 Topic Analysis</b-button>
            <b-button size="is-small" rounded  @click="search = 'Spam'">🕵️ Spam Detection</b-button>
            <b-button size="is-small" rounded  @click="search = 'Emergency'">🏥 Emergency Triage</b-button>
            <b-button size="is-small" rounded  @click="search = 'Paraphrase'">📜 Paraphrase</b-button>
            
            <b-button size="is-small" rounded  @click="search = 'Summarization'">📜 Summarization</b-button>
            
            
            <b-button size="is-small" rounded  @click="search = 'Named Entity Recognition'">🏷️ Named Entity Recognition</b-button>
          </div> -->
          
          
  <!-- <div class="block" v-if="currentUser && currentUser.plan.name != 'Pro'">
    <h4 class="title is-6">Current plan is Starter</h4>
    <h4 class="subtitle is-6">Upgrade to PRO plan for access to AI templates, datasets, models, and more.</h4>
  </div>
  <div class="block" v-if="currentUser">
    <h4 class="title is-6">Monthly usage</h4>
    <h4 class="subtitle is-6">Reset monthly
    </h4>
      <b-progress type="is-success" :max="currentUser.plan.predictionsLimit" :value="currentUser.predictionsTotal" show-value>
          Predictions {{ currentUser.predictionsTotal }} out of {{ currentUser.plan.predictionsLimit || currentUser.plan.predictions}}
      </b-progress>
  </div> -->

        </div>
        <div class="column">
          <h4 class="title is-4">
            <i class="fa fa-hub"></i> Pre-trained models &nbsp;
            
          </h4>
          

        <div class="boards-grid">
          
            
                <router-link class="card board" 
                  :to="'#'+model.id"
                  @click.native="openInference(model)"
                  v-for="(model, index) in searchModels()"
                  :key="index">
                  
                  <div class="card-content info" type="is-info">
                    
                    <div class="content">
                      <div class="media-content">
                        
                        <p class="name title is-5">
                          {{model.name}}
                        </p>
                        <p class="description is-6">
                          <span v-if="model.description != undefined">
                            {{ model.description }}
                          </span>
                          <span v-else>
                            &nbsp;
                          </span>
                        </p>
                      </div>
                    </div>

            <!-- <div class="bottom-left">
                
                <b-tag type="is-info">
                  teste
                </b-tag>
            </div> -->
            <div class="bottom-right">
                <b-tag size="is-small" type="is-white">
                    
                    <span v-if="model.type == 'extraction'" style="margin-bottom: 5px" data-entity="norp">{{ model.type }}</span>
                    <span v-else-if="model.type == 'generation'" style="margin-bottom: 5px" data-entity="person">{{ model.type }}</span>
                    <span v-else style="margin-bottom: 5px" data-entity="org">{{ model.type }}</span>
                </b-tag>
                
                <!-- <b-tag size="is-small" type="is-primary"><i class="fa fa-language"></i>&nbsp;multilingual</b-tag>&nbsp; -->
                <!-- <b-tag type="is-secondary">
                    <i class="fa fa-brain"></i> {{ model.type }}
                </b-tag> -->
            </div>
<!-- 
            <b-tag type="is-success" v-if="model.datasets && datasets">
                          {{ 
                            (
                              datasets.find(x => x.id === model.datasets[0]) !== undefined
                            ?
                              "dataset: "+datasets.find(x => x.id === model.datasets[0]).name
                            :
                            ""
                            )
                            
                          }}
                        </b-tag> -->
                    
                  </div>
                
                </router-link>
              
              </div>
        </div>
      </div>
    </div>
    <br>
    <br>
    
    



    <b-modal
              v-model="isSuggestModalActive"
              has-modal-card
              trap-focus
              :destroy-on-hide="true"
              :can-cancel="true"
              :full-screen="false"
              aria-role="dialog"
              aria-label="Dataset"
              aria-modal
              width="80%"
              scroll="clip">

            <div class="modal-card">
              <div class="columns">
              <div class="column is-full">
              <section class="modal-card-body">              
              <div class="page-title-container">
                    <h2 class="title is-2">Contact us</h2>
                    <h4 class="subtitle is-4">Use this form to suggest a pre-build model 💡, report an issue 🐞, request consulting service for your project</h4>
                
                    <b-field label="Subject">
                    <b-select v-model="contact_about" name="industry" required expanded placeholder="">
                      <option 
                      value='suggest'
                      selected>
                      Suggest a pre-build AI model
                      </option>
                      
                      <option v-for="i in [ 'Report an issue', 'Request consulting service', 'Schedule a product demo', 'Other']" 
                      :value="i">
                        {{ i }}</option>
                    </b-select>
                    </b-field>
                      
                    <b-field label="Your message">
                      <b-input required v-model="contact_msg" name="suggest" rows="5" type="textarea" 
                        placeholder="Type here"></b-input>
                    </b-field>

                    <b-field label="Your email" v-if="!currentUser">
                      <b-input required v-model="contact_email" name="email"
                        placeholder="Type here"></b-input>
                    </b-field>
                    
                    <b-button type="is-info" expanded @click="sendContactForm">Send</b-button>
    
                
              </div>
              

              </section>
              </div>
              </div>
            </div>

          </b-modal>


<!-- inference model-->
<b-modal
          v-model="isModalInferenceActive"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-label="Project"
          aria-modal  
          can-cancel
          width="80%"
          scroll="keep">
          <template #default="props">
              <modal-inference @close="props.close" :model="model" :currentUser="currentUser"></modal-inference>
          </template>
      </b-modal>

  </div>
</template>

<script>
import Inference from '@/components/ExploreInference.vue'
import list_models from '@/assets/json/models.json'
import PlanUsage from '@/components/PlanUsage.vue'
import 'vue-stepper-component'
export default {
  props: ["searchString"],
  name: "Explore",
  data() {
    return {
      data: [
          'Orange',
          'Apple',
          'Banana',
          'Pear',
          'Lemon',
          'Strawberry',
          'Kiwi'
      ],
      modelId: null,
      contact_about: 'suggest',
      contact_msg: null,
      contact_email: null,
      isSuggestModalActive: false,
      isModalInferenceActive: false,
      clearable: true,
      search: null,
      name: '',
      selected: null,
      models_preview: [],
      models: list_models
    };
  },
  components: {
    "modal-inference": Inference,
    PlanUsage
  },
  computed: {
    currentOrg() {
      return this.$store.state.currentOrg;
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    filteredDataArray() {
        return this.data.filter((option) => {
            return option
                .toString()
                .toLowerCase()
                .indexOf(this.name.toLowerCase()) >= 0
        })
    }
  },
  methods: {
    openInference(model){
        this.model = model
        this.isModalInferenceActive = true
    },
    sendContactForm(){

      let contactForm = {
        about: this.contact_about,
        msg: this.contact_msg,
        email: this.contact_email
      }

      if (this.currentUser){
        contactForm.email = this.currentUser.email
      }
      this.$store.dispatch("sendContactForm", contactForm);

      this.isSuggestModalActive = false

      this.$buefy.toast.open('Thank you!')
    },
    searchModels(){
      if(this.search || this.searchString){
        let s = (this.search)?this.search:this.searchString
        this.search = s
        let searchString = this.search.toLowerCase()
        return [...this.models, ...this.models_preview].filter( m => m.name.toLowerCase().includes(searchString) || m.type.toLowerCase().includes(searchString) || m.description.toLowerCase().includes(searchString))
      } else {
        return [...this.models, ...this.models_preview]
      }
    },
    showAddFruit() {
          this.$buefy.dialog.prompt({
              message: `Fruit`,
              inputAttrs: {
                  placeholder: 'e.g. Watermelon',
                  maxlength: 20,
                  value: this.name
              },
              confirmText: 'Add',
              onConfirm: (value) => {
                  this.data.push(value)
                  this.$refs.autocomplete.setSelected(value)
              }
          })
    }
  },
  created() {

    // this.$store.dispatch("retrievePublicModels");
    // this.$store.dispatch("retrievePublicDatasets");
    this.$store.dispatch("currentUser").then( (user) => {
        
        const organizationId = (this.currentUser.organizationId ? this.currentUser.organizationId : this.currentUser.id)

        this.$store.dispatch("currentOrg", organizationId);
      })
    
    // this.searchModels()

    // this.$store.dispatch('getPreBuildModels')

    if (this.models) {
        if (this.$route.hash != undefined){
            const _modelId = this.$route.hash.replace('#', '')
            if (_modelId != undefined){
                const _model = this.models.filter( m => m.id == _modelId)[0]
                if (_model != undefined){
                    this.openInference(_model)
                }
            }
        }
    }
    
  }, 
    
};
</script>

<style lang="scss" scoped>

.boards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 16px;
  
    .board {
      cursor: pointer;
      border: solid 1px #e6e4e4;
      border-radius: 4px;
      min-height: 10em;
  
      &:hover {
        background: #fafafa;
      }
  
      .info {
        padding: 16px;
        display:flex;
        flex-direction:column;
        justify-content:space-between
  
        .name {
          display: block;
          margin-bottom: 8px;
          text-transform: capitalize;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
  
        .description {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 0;
          margin-bottom: 8px;
          overflow: hidden;
        }

        .bottom-left {
          position: absolute;
          margin-top: auto;
          margin-bottom: 0.8em;
          bottom: 0;
          left: 0.8em;
        }
        .bottom-right {
          position: absolute;
          margin-top: auto;
          margin-bottom: 0.8em;
          bottom: 0;
          right: 0.8em;
        }
      }
    }
  }
</style>